import { ChartTypes } from "~/modules/asset_timeseries_v4/types";
import type { TimeSeriesPoint } from "~/modules/asset_timeseries_v4/types";
import { getTrailingAverage } from "./getTrailingAverage";

// // // //

interface YieldTimeSeriesChartView {
    item: any;
    enabled: boolean;
    chartType: ChartTypes;
}

interface GetTimeSeriesViewsProps {
    data: any[];
    displayStartDate?: string;
    trailingAverageDays?: number;
}

/**
 * Transforms raw timeseries data into TimeSeriesView[] for APY metrics.
 * Uses line charts to display yield performance over time.
 */
export function getTimeSeriesViews(
    props: GetTimeSeriesViewsProps,
): YieldTimeSeriesChartView[] {
    const { data, displayStartDate, trailingAverageDays } = props;
    const displayStartTimestamp = displayStartDate
        ? Date.parse(displayStartDate)
        : null;

    // Build TimeSeriesView[] from data with line chart type for APY data
    const series: YieldTimeSeriesChartView[] = data.map((each) => {
        const averagedPoints: TimeSeriesPoint[] = trailingAverageDays
            ? getTrailingAverage(each.points, trailingAverageDays)
            : each.points;
        const points =
            displayStartTimestamp === null
                ? averagedPoints
                : averagedPoints.filter(
                      ([date]) => Date.parse(date) >= displayStartTimestamp,
                  );

        return {
            item: { ...each, points },
            enabled: true,
            chartType: ChartTypes.line,
        };
    });

    return series;
}
